import { createContext, useReducer } from "react";
import chordReducer from "../reducers/chord-reducer";

const defaultBassValue = "Bass";

export const BassContext = createContext();
export const BassProvider = ({ children }) => {
  const [bassValue, dispatch] = useReducer(chordReducer, defaultBassValue);
  return (
    <BassContext.Provider value={{ bassValue, dispatch }}>
      {children}
    </BassContext.Provider>
  );
};
